import { Building2, Hash } from 'lucide-react'
import { useLocation, useNavigate } from 'react-router'

import { ToggleTabs } from '@/components/ui/ToggleTabs'
import { CarrierList } from './CarrierList'
import { NaicCompanies } from './NaicCompanies'

enum CarriersTab {
  CARRIERS = 'carriers',
  NAIC = 'naic',
}

function tabFromHash(hash: string): CarriersTab {
  const value = hash.slice(1)
  return Object.values<string>(CarriersTab).includes(value) ? (value as CarriersTab) : CarriersTab.CARRIERS
}

export function Carriers() {
  const location = useLocation()
  const navigate = useNavigate()
  const tab = tabFromHash(location.hash)

  function onTabChange(value: string) {
    void navigate(
      { search: location.search, hash: value === CarriersTab.CARRIERS ? '' : value },
      { replace: true, preventScrollReset: true }
    )
  }

  return (
    <div className="flex flex-col gap-6 p-6">
      <h1 className="text-2xl font-semibold">Carriers</h1>
      <ToggleTabs
        value={tab}
        onValueChange={onTabChange}
        className="w-full gap-4"
        items={[
          { value: CarriersTab.CARRIERS, icon: <Building2 />, label: 'Carriers' },
          { value: CarriersTab.NAIC, icon: <Hash />, label: 'NAIC' },
        ]}
      >
        {tab === CarriersTab.CARRIERS && <CarrierList />}
        {tab === CarriersTab.NAIC && <NaicCompanies />}
      </ToggleTabs>
    </div>
  )
}
